import React from 'react'
import { Box, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Drawer } from 'packages/eid-ui'
import { useIsSmallScreen } from 'packages/core'
import { useRequestItem, useApplicationSettings } from 'hooks'
import StickyContainer from 'components/StickyContainer'
import RequestItemDetails from './RequestItemDetails'
import { Button, TextFormatter } from 'components'

const HeaderContainer = styled(Box)({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 48px 10px 32px',
    overflow: 'hidden',
    color: '#ffffff',
    fontSize: '22px',
})

const DetailsDrawer = ({ id, onClose }) => {
    const {
        data: businessRequestItem,
        refetch,
        isLoading,
    } = useRequestItem(id)

    const { data: appConfig } = useApplicationSettings()

    const isSmallScreen = useIsSmallScreen()
    const { t } = useTranslation()

    if (isSmallScreen) {
        return (
            <Box>
                <StickyContainer
                    color="#ffffff"
                    styles={{
                        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <Box
                        width="100%"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        flexDirection="column"
                    >
                        <Box paddingY="10px" width="100%" maxWidth="260px">
                            <Button.BackButton onClick={() => onClose()}>
                                {t('Back')}
                            </Button.BackButton>
                        </Box>

                        <HeaderContainer
                            height="80px"
                            textAlign="start"
                            bgcolor={appConfig.style.colors.primary?.header}
                            style={{
                                backgroundImage:
                                    appConfig.style.colors.primary?.gradient,
                            }}
                        >
                            <TextFormatter
                                value={
                                    isLoading
                                        ? '-'
                                        : `${businessRequestItem?.itemTypeActionFriendlyName} - ${businessRequestItem?.friendlyName}`
                                }
                                maxCharacters={75}
                            />
                        </HeaderContainer>
                    </Box>
                </StickyContainer>

                {businessRequestItem && (
                    <RequestItemDetails
                        data={businessRequestItem}
                        refetch={refetch}
                    />
                )}
            </Box>
        )
    } else {
        return (
            <Drawer
                width="76%"
                open={true}
                toggleDrawer={() => onClose()}
                stickyHeader
                header={
                    <HeaderContainer
                        height="95px"
                        bgcolor={appConfig.style.colors.primary?.header}
                        style={{
                            backgroundImage:
                                appConfig.style.colors.primary?.gradient,
                        }}
                    >
                        <TextFormatter
                            value={
                                isLoading
                                    ? '-'
                                    : `${businessRequestItem?.itemTypeActionFriendlyName} - ${businessRequestItem?.friendlyName}`
                            }
                            maxCharacters={385}
                            style={{ maxHeight: '100%', overflow: 'hidden' }}
                        />
                    </HeaderContainer>
                }
                closeOnOutsideClick
            >
                {businessRequestItem && (
                    <RequestItemDetails
                        data={businessRequestItem}
                        refetch={refetch}
                    />
                )}
            </Drawer>
        )
    }
}

export default DetailsDrawer
